import {
  PEBackgroundOverviewCardActions,
  PEBackgroundOverviewCardGetters,
  PEBackgroundOverviewCardMutations,
} from './pe-background-overview-card'
import {
  PEFamilyOverviewCardActions,
  PEFamilyOverviewCardGetters,
  PEFamilyOverviewCardMutations,
} from './pe-family-overview-card'
import {
  PEHistoryOverviewCardActions,
  PEHistoryOverviewCardGetters,
  PEHistoryOverviewCardMutations,
} from './pe-history-overview-card'
import {
  PEPersonalOverviewCardActions,
  PEPersonalOverviewCardGetters,
  PEPersonalOverviewCardMutations,
} from './pe-personal-overview-card'
import {
  PeOverviewSummaryGetters,
  PeOverviewSummaryMutations,
  PeOverviewSummaryState,
} from './pe-overview-summary'

export const OverviewSectionActions = {
  ...PEBackgroundOverviewCardActions,
  ...PEFamilyOverviewCardActions,
  ...PEHistoryOverviewCardActions,
  ...PEPersonalOverviewCardActions,
}

export const OverviewSectionGetters = {
  ...PEBackgroundOverviewCardGetters,
  ...PEFamilyOverviewCardGetters,
  ...PEHistoryOverviewCardGetters,
  ...PEPersonalOverviewCardGetters,
  ...PeOverviewSummaryGetters,
}

export const OverviewSectionMutations = {
  ...PEBackgroundOverviewCardMutations,
  ...PEFamilyOverviewCardMutations,
  ...PEHistoryOverviewCardMutations,
  ...PEPersonalOverviewCardMutations,
  ...PeOverviewSummaryMutations,
}

export const OverviewSectionState = {
  ...PeOverviewSummaryState,
}
